// @ts-nocheck
export const getValidNumber = (amount: number | string | null) => {
  if (amount) {
    if (typeof amount === "string") {
      return toFixed(parseFloat(amount), 6);
    } else return amount;
  }
  return 0;
};

export function toFixed(num: number, fixed: number, round = true) {
  if (num && round) return parseFloat(Number(num).toFixed(fixed));
  const re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  if (num && !round) return parseFloat(num.toString().match(re)[0]);
  return 0;
}
export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
